import { render, staticRenderFns } from "./EnergyStatistics.vue?vue&type=template&id=47512568&scoped=true&"
import script from "./EnergyStatistics.vue?vue&type=script&lang=js&"
export * from "./EnergyStatistics.vue?vue&type=script&lang=js&"
import style0 from "./EnergyStatistics.vue?vue&type=style&index=0&id=47512568&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47512568",
  null
  
)

export default component.exports